export default __webpack_public_path__ + "static/media/velocity-use-case-img1.7cbaed63.png";